
<script lang="ts">
import { Options } from 'vue-class-component';
import {Vue} from 'vue-class-component';

@Options({
    name:'Empty',
    components: {},
    inheritAttrs:false,
    props: {
    }
})

export default class Empty extends Vue {
}
</script>
